import apiClient from './apiClient.js';

export const fetchVenueEvents = async (venue_id) => {
    const server_url = `/venue/events`;

    try {
        const response = await apiClient.get(server_url, {
            params: { venue_id },
        });

        return response.data.events;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchVenueParticipants = async (venue_id) => {
    const server_url = `/venue/participants`;

    try {
        const response = await apiClient.get(server_url, {
            params: { venue_id },
        });

        return response.data.participants;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchVenueStats = async (venue_id) => {
    const server_url = `/venue/stats`;

    try {
        const response = await apiClient.get(server_url, {
            params: { venue_id },
        });

        return response.data.stats;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

